import { isIOS } from './pwa-environment';

const CONTROLLER_CHANGE_TIMEOUT_MS = isIOS() ? 8_000 : 3_000;

/**
 * Forza reload aggressivo — funziona in PWA standalone e browser.
 */
function forceReload(): void {
  try {
    // Metodo 1: reload standard
    window.location.reload();
  } catch {
    // Metodo 2: redirect a stessa URL
    window.location.assign(window.location.href);
  }
  // Metodo 3: fallback con timeout se i primi non hanno effetto
  setTimeout(() => {
    window.location.replace(window.location.pathname + window.location.search);
  }, 500);
}

/**
 * Attiva il nuovo service worker (SKIP_WAITING) e ricarica la pagina.
 * Opzionale callback prima del reload (es. pulizia dati offline).
 */
export async function applyServiceWorkerUpdate(
  registration: ServiceWorkerRegistration | null,
  options?: { onBeforeReload?: () => Promise<void> }
): Promise<void> {
  if (options?.onBeforeReload) {
    await options.onBeforeReload();
  }
  if (!registration?.waiting) {
    forceReload();
    return;
  }
  let reloaded = false;
  const doReload = () => {
    if (reloaded) return;
    reloaded = true;
    forceReload();
  };
  navigator.serviceWorker.addEventListener('controllerchange', doReload, { once: true });
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  // Timeout ridotto + reload forzato
  setTimeout(doReload, CONTROLLER_CHANGE_TIMEOUT_MS);
}
